// extracted by mini-css-extract-plugin
module.exports = {"resetPassword":"ResetPassword_resetPassword__2jhMY","submit":"ResetPassword_submit__2DJ1Q","success":"ResetPassword_success__1JXPh","error":"ResetPassword_error__2fQ_h"};